import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ApplicationShell } from '../index';
import { useSelector } from 'react-redux';
import { selectAuthIsFetching } from '../../redux/selectors/authSelectors';
import '../../Sass/theme.scss';

const ProfileLayout = () => {
  const isFetching = useSelector(selectAuthIsFetching);

  return (
    <ApplicationShell>
      <ToastContainer />
      {isFetching && (
        <div className='pagepreloader-wrapper'>
          <div className='preloader'></div>
          <div className='pageoverlay'></div>
        </div>
      )}
      <div className='header'>
        <Row>
          <Col>
            <div className='content content-full-width'>
              <div className='profile-header'></div>
            </div>
          </Col>
        </Row>
      </div>
      <Row className='g-0'>
        <Col lg={12} className='DivMain'>
          <Outlet />
        </Col>
      </Row>
    </ApplicationShell>
  );
};

export default ProfileLayout;
